import {
  Box,
  Typography,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useBrandContext } from "../App";
import { brands } from "../data";
import { Close } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { globalWordings } from "../data";
import { useParams, useLocation } from "react-router-dom";

export const Footer = () => {
  const { brand } = useBrandContext();
  const { lang } = useParams();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
  }, [pathname]);

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "primary.main",
        color: "primary.contrastText",
      }}
      className="footer"
    >
      <Container
        component="nav"
        maxWidth="lg"
        sx={{
          height: 75,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 0,
        }}
      >
        <Box component="img" src={brands[brand].logo} alt="logo" height={41} />
        <Box component={Link} color="link.main" onClick={() => setOpen(true)}>
          <Typography
            variant="bold"
            fontSize={12}
            sx={{ textTransform: "uppercase" }}
          >
            {globalWordings[lang]?.footer?.alcohol}
          </Typography>
        </Box>
      </Container>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          <Box display="flex" justifyContent="flex-end">
            <IconButton onClick={() => setOpen(false)}>
              <Close sx={{ color: "primary.contrastText" }} />
            </IconButton>
          </Box>
          <Typography
            variant="caption"
            sx={{
              fontSize: "14px !important",
            }}
          >
            {globalWordings[lang]?.footer?.modal?.title}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ maxHeight: 500 }}>
          <Typography
            variant="caption"
            sx={{
              fontSize: "14px !important",
            }}
          >
            {globalWordings[lang]?.footer?.modal?.responsibleConsumption}
          </Typography>
          {globalWordings[lang]?.footer?.modal?.link && (
            <Typography
              variant="caption"
              component="p"
              sx={{
                fontSize: "14px !important",
                mt: 2,
              }}
            >
              Read more on{" "}
              <Box
                component="a"
                href={globalWordings[lang]?.footer?.modal?.link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "link.main" }}
              >
                ModerationMatters.com
              </Box>
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};
